import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import classNames from 'classnames';
import Tooltip from '../tooltip/Tooltip';
import OverlayTrigger from '../overlay/OverlayTrigger';
import { TOP } from './StatusBarConstants';
export const StatusBarProgressBar = (props) => {
    const { index, progress: { className, color, percentage = 0, tooltip, tooltipDelay = 50, tooltipPosition = TOP }, useProgressDivider, } = props;
    const progressBarClasses = classNames('progress-bar', color !== null && color !== void 0 ? color : 'progress-bar-info', useProgressDivider && 'progress-divider', className);
    const progressBar = _jsx("div", { className: progressBarClasses, style: { width: `${percentage}%` } });
    if (!tooltip) {
        return progressBar;
    }
    return (_jsx(OverlayTrigger, Object.assign({ placement: tooltipPosition, overlay: _jsx(Tooltip, Object.assign({ id: `tooltip-${index}`, width: 'auto' }, { children: tooltip })), delay: tooltipDelay }, { children: progressBar })));
};
export default StatusBarProgressBar;
